// @generated by TypeGen from LogbookModel/User.swift - DO NOT EDIT

export interface IUser {
  id: number;
  accountId?: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  activatedAt?: string;
  deletedAt?: string;
  authenticationType: IUserAuthenticationType;
  name: string;
  email: string;
  metadata?: string;
  shortname: string;
  language?: string;
}

export interface IUserResponse {
  user: IUser;
}

export interface IUsersResponse {
  users: IUser[];
}

export enum IUserAuthenticationType {
  none = 0,
  invited = 1,
  password = 2,
  apple = 3,
  google = 4,
  client = 10,
}
